import React from "react";
import { Smartphone, Tablet } from "lucide-react";
interface MobileNotAllowedOverlayProps {
  deviceType: "mobile" | "tablet" | "desktop";
  isMobileViewport: boolean;
}

const MobileNotAllowedOverlay: React.FC<MobileNotAllowedOverlayProps> = ({
  deviceType,
  isMobileViewport,
}) => {
  const getDeviceIcon = () => {
    if (deviceType === "mobile") {
      return <Smartphone size={64} color="#4A3CFA" />;
    }
    return <Tablet size={64} color="#4A3CFA" />;
  };

  const getTitle = () => {
    if (deviceType === "mobile") {
      return "Not Available On Mobile";
    } else if (deviceType === "tablet") {
      return "Not Available On Tablet";
    } else if (isMobileViewport) {
      return "Not Available On Current Viewport";
    }
    return "Device Not Supported";
  };

  const getMessage = () => {
    return "Looks like you’re on a mobile, tablet or a small screen. For the best experience, open this on a desktop or laptop.";
  };

  return (
    <div className="mobile-not-allowed-overlay">
      <div className="overlay-content">
        <div className="device-icon">
          {getDeviceIcon()}
          <div className="title">{getTitle()}</div>
        </div>

        <div className="message">{getMessage()}</div>

        <div className="action-buttons">
          <div className="minimum-resolution">
            Tip: a window size of 1024 × 768 or larger works great.
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileNotAllowedOverlay;
